function moveProductForm() {
    console.log('execute moveProductForm function')

    const dropContainer = document.querySelector('[data-drop-product-form]')
    const priceForm = document.querySelector('[data-drops-price-form]')
    const variantsForm = document.querySelector('[data-drops-variant-form]')
    const quantityForm = document.querySelector('[data-drops-quantity-form]')
    const buttonsForm = document.querySelector('[data-drops-buttons-form]')

    const dropPrice = document.querySelector('[data-drop-price-form]')

    dropPrice.appendChild(priceForm)
    dropContainer.appendChild(variantsForm)
    dropContainer.appendChild(quantityForm)
    dropContainer.appendChild(buttonsForm)

    return
}

function restoreProductForm() {
    
    console.log('execute restoreProductForm function')

    const priceForm = document.querySelector('[data-drops-price-form]')
    const variantsForm = document.querySelector('[data-drops-variant-form]')
    const quantityForm = document.querySelector('[data-drops-quantity-form]')
    const buttonsForm = document.querySelector('[data-drops-buttons-form]')

    const restorePrice = document.querySelector('[data-drops-price-restore]')
    const restoreVariant = document.querySelector('[data-drops-variant-restore]')
    const restoreButtons = document.querySelector('[data-drops-buttons-restore]')
    const quantityButtons = document.querySelector('[data-drops-quantity-restore]')

    restorePrice.appendChild(priceForm)
    restoreVariant.appendChild(variantsForm)
    quantityButtons.appendChild(quantityForm)
    restoreButtons.appendChild(buttonsForm)

    return
}